import React, {memo} from 'react'
import PropTypes from 'prop-types'
import Hidden from '@material-ui/core/Hidden'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'

import logoImage from '../assets/images/logos/logo.svg'
import './Header.scss'

const navLinks = [
  {id: 1, title: 'Our mission', href: '#mission'},
  {id: 2, title: 'Services', href: '#services'},
  {id: 3, title: 'Benefits', href: '#benefits'},
  {id: 4, title: 'Our packs', href: '#packs'},
  {id: 5, title: 'Portfolio', href: '#portfolio'},
  {id: 6, title: 'Faq', href: '#faq'},
  {id: 7, title: 'Agency', href: '#agency'},
]

const renderedNavLinks = navLinks.map(link => (
  <li key={link.id} className="Header-Item">
    <a className="Header-Link" href={link.href}>
      {link.title}
    </a>
  </li>
))

Header.propTypes = {
  isLoaded: PropTypes.bool.isRequired,
}

function Header({isLoaded}) {
  const image = <img className="Header-Image" src={logoImage} width={218} height={42} alt="7glyphs Lite" />
  return (
    <header className="Header Container">
      <Grid container spacing={2}>
        <Hidden mdDown>
          <Grid item xs={1} />
        </Hidden>
        <Grid item xs={12} lg={10}>
          <div className="Header-Content">
            {isLoaded ? <div className="Header-Logo">{image}</div> : image}
            <Hidden xsDown>
              {isLoaded && (
                <nav className="Header-Navigation">
                  <Hidden smDown>
                    <ul className="Header-List">{renderedNavLinks}</ul>
                  </Hidden>
                  <div className="Header-Button">
                    <Button component="a" variant="outlined" href="#contact">
                      Contact us
                    </Button>
                  </div>
                </nav>
              )}
            </Hidden>
          </div>
        </Grid>
        <Hidden mdDown>
          <Grid item xs={1} />
        </Hidden>
      </Grid>
    </header>
  )
}

export default memo(Header)
